import { FormBase } from "../../util/form-base-form";

export class BoardConfigAdminForm extends FormBase {
    public root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public static getRoots(root: ParentNode): HTMLElement[] {
        return new BoardConfigAdminForm(document.body).queryElements(root, ".board-configs-admin", HTMLElement);
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public isInitialized(): boolean {
        return this.root.dataset.boardConfigsAdminInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.boardConfigsAdminInit = "1";
    }

    public getListEl(): HTMLElement | null {
        return this.queryElement(this.root, ".users-admin__list", HTMLElement);
    }

    public getEditButton(root: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(root, ".js-board-config-edit-toggle", HTMLButtonElement);
    }

    public getRow(root: EventTarget | Element | null | undefined): HTMLFormElement | null {
        return this.closest(root, ".users-admin__row", HTMLFormElement);
    }

    public getSubmitButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, 'button[type="submit"]', HTMLButtonElement);
    }

    public getModalUsageDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="modal_usage"]', HTMLElement);
    }

    public getListStyleDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="list_style"]', HTMLElement);
    }

    public getTitleEnabledDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="title_enabled"]', HTMLElement);
    }

    public getProductLinkerShowDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="product_linker_show"]', HTMLElement);
    }

    public getTargetProductShowDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="target_product_show"]', HTMLElement);
    }

    public getOgpPreviewShowDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="ogp_preview_show"]', HTMLElement);
    }

    public getUserInfoShowDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="user_info_show"]', HTMLElement);
    }

    public getShowContentDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="show_content"]', HTMLElement);
    }

    public getRatingOverlayShowDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="rating_overlay_show"]', HTMLElement);
    }

    public getDateShowDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="date_show"]', HTMLElement);
    }

    public getUpdatedAtDisplay(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, '[data-field="updated_at"]', HTMLElement);
    }

    public getFieldSelect(root: ParentNode, name: string): HTMLSelectElement | null {
        return this.queryElement(root, `select[name="${name}"]`, HTMLSelectElement);
    }
}
